<script setup>
import {useConfigurateurStore} from "../../stores/configurateur";
import {computed, onMounted} from "vue";

const store = useConfigurateurStore();

let scrollSpyContainer;
let sections;
let manualGoToStep = false;

const goToStep = (step) => {
    manualGoToStep = true
    const targetId = '#step-' + step;
    const targetEl = document.querySelector(targetId);
    if (targetEl) {
        targetEl.scrollIntoView({behavior: "smooth"});
    }
    setTimeout(() => {
        manualGoToStep = false
    }, 500)
}

const handleClickStep = (step, hasGoToStep = true) => {
    store.setStep(step)
    if (hasGoToStep) {
        goToStep(step)
    }
}

const updateActiveStep = () => {
    if (!scrollSpyContainer || manualGoToStep) return;
    let closestSection = null;
    let minDistance = Infinity;

    sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const containerRect = scrollSpyContainer.getBoundingClientRect();

        if (scrollSpyContainer.scrollTop <= 10) {
            closestSection = sections[0];
            return;
        }

        if (rect.bottom > containerRect.top && rect.top < containerRect.bottom) {
            const distanceFromTop = Math.abs(rect.top - containerRect.top);
            if (distanceFromTop < minDistance) {
                minDistance = distanceFromTop;
                closestSection = section;
            }
        }
    });

    if (closestSection) {
        const visibleId = closestSection.getAttribute("id");
        const step = visibleId.replace('step-', '');
        if (step != store.step) {
            handleClickStep(step, false)
        }
    }
}

onMounted(() => {
    goToStep(store.step)
    scrollSpyContainer = document.querySelector(".scrollspy");
    sections = document.querySelectorAll(".scrollspy section[id^='step']");
    if (scrollSpyContainer) {
        scrollSpyContainer.addEventListener("scroll", updateActiveStep);
    }
    document.querySelector('body').addEventListener('next-step', (e) => {
        handleClickStep(store.next_step)
    })

    document.querySelector('body').addEventListener('prev-step', (e) => {
        handleClickStep(store.prev_step)
    })
})

</script>

<template>
    <ul class="stepper nav nav-pills nav-scroll-stepper mt-1 mb-4">
        <li class="nav-item" v-for="(step, index) in store.steps" :key="step">
            <a
                class="nav-link nav-step"
                :class="{'active': step == store.step, 'completed': store.isCompleted(step)}"
                :href="'#step-' + step"
                @click.prevent="handleClickStep(step)"
            >
                <div class="circle">{{ index + 1 }}</div>
                <span>{{ $t(step) }}</span>
            </a>
        </li>
    </ul>
</template>

<style scoped>

</style>
